import { createSelector } from 'reselect'
import { AppState } from 'reducers'
import * as storesActionTypes from 'services/Stores/actionTypes'
import * as locationActionTypes from 'services/Location/actionTypes'
import * as cmsActionTypes from 'services/cms/actionTypes'
import { ErrorBody } from './error'
import * as statesActionTypes from 'services/States/actionTypes'

const activeRequest = (state: AppState) => state.request.activeRequests

export const getRequestError = (key: string) => (
  state: AppState,
): ErrorBody | undefined => state.request.errors[key]

export const requestIsSearchingSelector = createSelector(
  activeRequest,
  activeRequests =>
    [
      storesActionTypes.SEARCH_REQUESTED,
      storesActionTypes.SEARCH_ALL_STORES_REQUESTED,
      locationActionTypes.GEO_REQUESTED,
    ].some(actiontype => activeRequests.includes(actiontype)),
)

export const requestIsGetStoreDetailSelector = createSelector(
  activeRequest,
  activeRequests =>
    activeRequests.includes(storesActionTypes.DETAILS_REQUESTED),
)

export const requestIsGetStateSelector = createSelector(
  activeRequest,
  activeRequests =>
    activeRequests.includes(statesActionTypes.STATES_FOR_REGION_REQUESTED),
)

export const requestIsFetchingCMSSelector = createSelector(
  activeRequest,
  activeRequests => activeRequests.includes(cmsActionTypes.CMS_DATA_REQUESTED),
)
